import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './signature-audit-log.reducer';

export const SignatureAuditLogDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const signatureAuditLogEntity = useAppSelector(state => state.signatureAuditLog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="signatureAuditLogDetailsHeading">
          <Translate contentKey="crawlerBackendApp.signatureAuditLog.detail.title">SignatureAuditLog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{signatureAuditLogEntity.id}</dd>
          <dt>
            <span id="eventType">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.eventType">Event Type</Translate>
            </span>
          </dt>
          <dd>{signatureAuditLogEntity.eventType}</dd>
          <dt>
            <span id="actor">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.actor">Actor</Translate>
            </span>
          </dt>
          <dd>{signatureAuditLogEntity.actor}</dd>
          <dt>
            <span id="ipAddress">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.ipAddress">Ip Address</Translate>
            </span>
          </dt>
          <dd>{signatureAuditLogEntity.ipAddress}</dd>
          <dt>
            <span id="eventTimestamp">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.eventTimestamp">Event Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {signatureAuditLogEntity.eventTimestamp ? (
              <TextFormat value={signatureAuditLogEntity.eventTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="note">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.note">Note</Translate>
            </span>
          </dt>
          <dd>{signatureAuditLogEntity.note}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.signatureAuditLog.signingSession">Signing Session</Translate>
          </dt>
          <dd>{signatureAuditLogEntity.signingSession ? signatureAuditLogEntity.signingSession.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/signature-audit-log" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/signature-audit-log/${signatureAuditLogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SignatureAuditLogDetail;
